import { defineStore } from 'pinia';
import Translation from '@/data/translation.js';
import { ref } from 'vue';

export const useTranslationStore = defineStore('translation', () => {
  const data = ref(Translation);

  return {
    data,
  };
});
